// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fp-page-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 20px;
}

.fp-modal-box {
    background: #ffffff;
    width: 100%;
    max-width: 440px;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    animation: fpFadeIn 0.3s ease-in-out;
}

@keyframes fpFadeIn {
    from { opacity: 0; transform: translateY(-15px); }
    to { opacity: 1; transform: translateY(0); }
}

.fp-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 25px 15px 25px;
    border-bottom: 1px solid #f0f0f0;
}

.fp-header-title-area {
    display: flex;
    align-items: center;
    gap: 12px;
}

.fp-top-icon {
    background: rgba(118, 75, 162, 0.12);
    color: #764ba2;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.fp-heading {
    color: #333;
    font-size: 18px;
    font-weight: 700;
    margin: 0;
}

.fp-close-btn {
    background: none;
    border: none;
    font-size: 18px;
    color: #888;
    cursor: pointer;
    transition: color 0.2s;
}

.fp-close-btn:hover {
    color: #333;
}

.fp-form {
    padding: 25px;
}

.fp-instruction {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.5;
}

.fp-input-group {
    position: relative;
    margin-bottom: 18px;
}

.fp-input-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #888;
    font-size: 14px;
}

.fp-input-field {
    width: 100%;
    padding: 12px 15px 12px 42px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
    box-sizing: border-box;
}

.fp-input-field:focus {
    border-color: #764ba2;
}

.fp-alert {
    padding: 10px 15px;
    margin: 0 25px;
    border-radius: 6px;
    font-size: 13px;
    text-align: center;
}

.fp-alert-error {
    background-color: #ffe6e6;
    color: #d9534f;
    border: 1px solid #f5c6cb;
}

.fp-alert-success {
    background-color: #e6f4ea;
    color: #28a745;
    border: 1px solid #c3e6cb;
}

.fp-button-container {
    display: flex;
    gap: 12px;
    margin-top: 10px;
}

.fp-btn-primary {
    flex: 1 1;
    background: #764ba2;
    color: white;
    border: none;
    padding: 12px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

.fp-btn-primary:hover {
    background: #5a3880;
}

.fp-btn-secondary {
    flex: 1 1;
    background: #f1f1f1;
    color: #444;
    border: none;
    padding: 12px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

.fp-btn-secondary:hover {
    background: #e2e2e2;
}`, "",{"version":3,"sources":["webpack://./src/pages/ForgotPassword.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,6DAA6D;IAC7D,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,OAAO,UAAU,EAAE,4BAA4B,EAAE;IACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,4BAA4B;IAC5B,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".fp-page-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    padding: 20px;\n}\n\n.fp-modal-box {\n    background: #ffffff;\n    width: 100%;\n    max-width: 440px;\n    border-radius: 12px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    animation: fpFadeIn 0.3s ease-in-out;\n}\n\n@keyframes fpFadeIn {\n    from { opacity: 0; transform: translateY(-15px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.fp-modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 22px 25px 15px 25px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n.fp-header-title-area {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.fp-top-icon {\n    background: rgba(118, 75, 162, 0.12);\n    color: #764ba2;\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.fp-heading {\n    color: #333;\n    font-size: 18px;\n    font-weight: 700;\n    margin: 0;\n}\n\n.fp-close-btn {\n    background: none;\n    border: none;\n    font-size: 18px;\n    color: #888;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.fp-close-btn:hover {\n    color: #333;\n}\n\n.fp-form {\n    padding: 25px;\n}\n\n.fp-instruction {\n    font-size: 14px;\n    color: #666;\n    margin-bottom: 20px;\n    line-height: 1.5;\n}\n\n.fp-input-group {\n    position: relative;\n    margin-bottom: 18px;\n}\n\n.fp-input-icon {\n    position: absolute;\n    left: 14px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #888;\n    font-size: 14px;\n}\n\n.fp-input-field {\n    width: 100%;\n    padding: 12px 15px 12px 42px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s;\n    box-sizing: border-box;\n}\n\n.fp-input-field:focus {\n    border-color: #764ba2;\n}\n\n.fp-alert {\n    padding: 10px 15px;\n    margin: 0 25px;\n    border-radius: 6px;\n    font-size: 13px;\n    text-align: center;\n}\n\n.fp-alert-error {\n    background-color: #ffe6e6;\n    color: #d9534f;\n    border: 1px solid #f5c6cb;\n}\n\n.fp-alert-success {\n    background-color: #e6f4ea;\n    color: #28a745;\n    border: 1px solid #c3e6cb;\n}\n\n.fp-button-container {\n    display: flex;\n    gap: 12px;\n    margin-top: 10px;\n}\n\n.fp-btn-primary {\n    flex: 1;\n    background: #764ba2;\n    color: white;\n    border: none;\n    padding: 12px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.fp-btn-primary:hover {\n    background: #5a3880;\n}\n\n.fp-btn-secondary {\n    flex: 1;\n    background: #f1f1f1;\n    color: #444;\n    border: none;\n    padding: 12px;\n    border-radius: 8px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.fp-btn-secondary:hover {\n    background: #e2e2e2;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
